import styled from "styled-components";
import { ReactComponent as Expand } from "assets/images/mobile/expand.svg";
import { fonts } from "styles";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  padding: 6px 36px;
  font-family: ${fonts.BentonSansMedium};
  font-size: 13px;
  line-height: 26px;
  text-transform: uppercase;
  border-radius: 32px;
  position: absolute;
  column-gap: 8px;

  animation-delay: 2s;
  animation-name: fadeOut;
  animation-duration: 700ms;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
  animation-fill-mode: both;

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`;

export const Icon = styled(Expand)``;
